import { Link } from 'react-router';
import { mixins } from 'consumer-components';
import { css, StyleSheet } from 'aphrodite';
import * as React from 'react';

import { WindowWrapper } from 'login-utils/globalWrappers';

/**
 * Just like react-router's link, but wraps it to also pass through things like
 * query parameters and everything else on the current location.
 */

interface ContextLinkProps extends React.HTMLAttributes<Link> {
  to: string;
  isWhite?: boolean;
}

const loginBackgroundColor = WindowWrapper.DEPLOYMENT_CONFIG.organization.colors.loginBackground;

const styles = StyleSheet.create({
  dynamicLink: {
    color: mixins.dynamicColor(loginBackgroundColor),
  },
});

const ContextLink = ({ to, children, ...props }: ContextLinkProps) => (
  <Link
    className={css(props.isWhite ? styles.dynamicLink : null)}
    {...props}
    to={location => ({ ...location, pathname: `/${to}` })}
  >
    {children}
  </Link>
);

export default ContextLink;
